export default __webpack_public_path__ + "static/media/search.f002935d.svg";